import React from 'react';

export default function PageHero({ title, subtitle, subtitle2, image }) {
  return (
    <section className="relative pt-32 pb-24 px-6 overflow-hidden bg-secondary">
      {image && (
        <div
          className="absolute inset-0 z-0 opacity-20 bg-cover bg-center"
          style={{ backgroundImage: `url(${image})` }}
        />
      )}
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-snug tracking-normal">
          {title}
        </h1>
        {subtitle && (
          <p className="text-xl text-gray-200 font-light max-w-2xl mx-auto leading-relaxed">
            {subtitle}
          </p>
        )}
        {subtitle2 && (
          <p className="text-xl text-gray-200 font-light max-w-2xl mx-auto leading-relaxed">
            {subtitle2}
          </p>
        )}
      </div>
    </section>
  );
}